"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Element = void 0;
var React = require("react");
var TreeviewCheckBox_1 = require("../TreeviewCheckBox/TreeviewCheckBox");
var Element_style_1 = require("./Element.style");
exports.Element = React.forwardRef(function (_a, ref) {
    var Data = _a.Data, OnClickElement = _a.OnClickElement, IsReadOnly = _a.IsReadOnly, HighlightedString = _a.HighlightedString;
    // tslint:disable-next-line: no-empty
    React.useImperativeHandle(ref, function () { return ({ FireAddClick: function () { } }); }); // I added this to avoid the "Cannot read property 'FireAddClick' of null" error.
    return (!IsReadOnly ?
        React.createElement(Element_style_1.ElementDiv, { IsFolder: Data.Folder },
            React.createElement(TreeviewCheckBox_1.TreeviewCheckBox, { Data: Data, OnClickElement: OnClickElement, HighlightedString: HighlightedString })) :
        React.createElement(Element_style_1.ElementDiv, { IsFolder: Data.Folder }, Data.Caption));
});
